import { render, staticRenderFns } from "./certificateListing.vue?vue&type=template&id=2b30bfb3&"
import script from "./certificateListing.vue?vue&type=script&lang=js&"
export * from "./certificateListing.vue?vue&type=script&lang=js&"
import style0 from "./certificateListing.vue?vue&type=style&index=0&id=2b30bfb3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports